import fr from 'facet-rest';
import { FDHeadlineText } from '@facet-wealth/design';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export default fr.metaOverride()
  .overrideAll({
    _hideLabel: true,
  }, { ordinal: 200 })
  .nameOverride('title', {
    _component: () => FDHeadlineText,

  }, overrideReadOnly);
